import { specialistRequests } from "api/specialistApi";
import permissions from "app/permissions";
import { settings } from "app";
import {
  AutocompleteInput,
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceInput,
  SelectField,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { GenderOptionsId } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";

const specialistFilters = [
  <TextInput
    label="Имена"
    source="userName"
    style={{ width: 300 }}
    alwaysOn
  />,
  <ReferenceInput
    source="specializationId"
    reference={specialistRequests.getSpecializationsSelect()}
    label="Специалност"
    style={{ width: 300 }}
    alwaysOn
  >
    <AutocompleteInput
      label="Специалност"
      style={{ width: 300 }}
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
    />
  </ReferenceInput>,
  <TextInput
    label="Специалност (текст)"
    source="specializationName"
    style={{ width: 300 }}
    alwaysOn
  />,
];

const ListSpecialists = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Специализанти"
      filters={specialistFilters}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                {
                  label: "Имена",
                  value: record?.userInfo.secondName
                    ? `${record?.userInfo.firstName} ${record?.userInfo.secondName} ${record?.userInfo.lastName}`
                    : `${record?.userInfo.firstName} ${record?.userInfo.lastName}`,
                },
              ]}
            />
          )}
          secondaryText={() => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "ЕГН",
                    value: (
                      <TextField
                        source="userInfo.personId"
                        emptyText="-"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Пол",
                    value: (
                      <SelectField
                        source="userInfo.gender"
                        choices={GenderOptionsId}
                        emptyText="-"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Имейл",
                    value: (
                      <TextField
                        source="userInfo.email"
                        emptyText="-"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <TextField
                        source="specializationNameBg"
                        emptyText="-"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Записан на",
                    value: (
                      <DateField
                        source="enrolledOn"
                        showTime={false}
                        locales="bg-BG"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <SecuredComponent permission={permissions.canPreviewSpecialists}>
              <ShowButton label="" />
            </SecuredComponent>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <FunctionField
            label="Имена"
            render={rec =>
              rec?.userInfo.secondName
                ? `${rec?.userInfo.firstName} ${rec?.userInfo.secondName} ${rec?.userInfo.lastName}`
                : `${rec?.userInfo.firstName} ${rec?.userInfo.lastName}`
            }
          />
          <TextField
            label="ЕГН"
            source="userInfo.personId"
            sortable={false}
            emptyText="-"
          />
          <SelectField
            label="Пол"
            source="userInfo.gender"
            choices={GenderOptionsId}
            emptyText="-"
          />
          <TextField
            label="Имейл"
            source="userInfo.email"
            sortable={false}
            emptyText="-"
          />
          <TextField
            source="specializationNameBg"
            label="Специалност"
            sortable={false}
            emptyText="-"
          />
          <DateField
            source="enrolledOn"
            label="Записан на"
            showTime={false}
            sortable={false}
            locales="bg-BG"
          />
          <SecuredComponent permission={permissions.canPreviewSpecialists}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListSpecialists;
